var Base = require('_js/base'),
  ko = require('knockout');

var FilterInterest = function(params, parent) {
  this.filterTopic = 'disciplineInterestsCategoryFilter';
  this.CategoryKey = ko.observable(params.CategoryKey);
  this.CategoryName = ko.observable(params.CategoryName);
  this.Checked = ko.observable(params.Checked);

  this.Checked.subscribe(function() {
    ko.postbox.publish(this.filterTopic, {
      Categories: getCheckedCategoryKeysFromKO(parent)
    });
  }, this);
};

function getCheckedCategoryKeysFromKO(parent) {
  var koCategories = parent.getFilters();
  var categories = [];
  for (var i = 0; i < koCategories.length; i++) {
    if (koCategories[i].Checked()) {
      categories.push(koCategories[i].CategoryKey());
    }
  }
  return categories;
}

function FilterInterests(params) {
  this.filters = ko.observableArray([]);
  this.filterTopic = 'disciplineInterestsCategoryFilter';
  for (var i = 0; i < params.filters.length; i++) {
    this.filters.push(new FilterInterest(params.filters[i], this));
  }

  ko.postbox.publish(this.filterTopic, {
    Categories: getCheckedCategoryKeysFromKO(this)
  });
}

FilterInterests.prototype.getFilters = function() {
  return this.filters();
};

// > example
function DisciplineInterests() {
  this.init();
}

DisciplineInterests.prototype = new Base();

DisciplineInterests.prototype.init = function() {
  $('[data-interests-filter]').each(function() {
    ko.applyBindings(
      new FilterInterests($(this).data('interests-filter')),
      this
    );
  });
};

module.exports = DisciplineInterests;
